import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";
import { normalizeSetupSearchCode } from "../lib/auth/user-setup-search";

/** Verify-email now lives on account-web — bounce old bookmarks. */
export const Route = createFileRoute("/verify-email")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/verify-email", window.location.search);
      haltForExternalNavigation();
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    email: (search.email as string) || undefined,
    code: normalizeSetupSearchCode(search.code),
  }),
  component: () => null,
});
